import moment from "moment";
import { parseRange } from "@/components/report/desktop/reportQuery";

export { parseRange };

/**
 * Stanje Finansija u adresi (hash router: /#/restoran/finansije?t=transactions&from=…&to=…&v=ledger).
 * Prvi tab, ovaj mjesec i prikaz "po transakciji" se izostavljaju.
 */
export const FINANCE_QUERY = { tab: "t", from: "from", to: "to", view: "v" };

export const FINANCE_TABS = ["earnings", "settlements", "transactions", "contract"];
export const DEFAULT_FINANCE_TAB = "earnings";
export const TX_VIEWS = ["order", "ledger", "refunds"];
export const DEFAULT_TX_VIEW = "order";

const ISO = "YYYY-MM-DD";

/**
 * Brzi izbori perioda. Finansije gledaju unazad do danas (knjiži se samo ono što se desilo), pa "ovaj mjesec"
 * ide od prvog do današnjeg dana, a ne do kraja mjeseca.
 * @returns {Array<{ key: string, from: string, to: string }>}
 */
export const buildFinancePresets = (today = moment()) => {
  const day = moment(today).startOf("day");
  const range = (from, to) => ({ from: from.format(ISO), to: to.format(ISO) });
  const lastMonth = day.clone().subtract(1, "month");
  return [
    { key: "this_month", ...range(day.clone().startOf("month"), day) },
    { key: "last_month", ...range(lastMonth.clone().startOf("month"), lastMonth.clone().endOf("month")) },
    { key: "last_30", ...range(day.clone().subtract(29, "days"), day) },
    { key: "last_90", ...range(day.clone().subtract(89, "days"), day) },
    { key: "this_year", ...range(day.clone().startOf("year"), day) },
  ];
};

export const findPresetKey = (presets, from, to) =>
  (presets.find((preset) => preset.from === from && preset.to === to) || {}).key || null;
